import React from 'react';
import './Terms.css';

const TermsDE = () => {
  return (
    <div className="terms-page">
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
      <div className="terms-main">
        <p>
          Willkommen bei Rewards & Samples, LLC ("wir", "unser" oder "uns"). Durch den Zugriff 
          auf und die Nutzung unserer Website erklären Sie sich mit den folgenden Bedingungen 
          einverstanden.
        </p>

        <h3>1. NUTZUNGSBEDINGUNGEN</h3>
        <p>
          Diese Website wird von Rewards & Samples, LLC betrieben. Durch die Nutzung dieser 
          Website stimmen Sie zu, an diese Nutzungsbedingungen, alle geltenden Gesetze und 
          Vorschriften gebunden zu sein.
        </p>

        <h3>2. BERECHTIGUNG</h3>
        <p>
          Um an unserem Prämienprogramm teilzunehmen, müssen Sie:
        </p>
        <ul>
          <li>Mindestens 18 Jahre alt sein</li>
          <li>Einen rechtmäßigen Wohnsitz in Deutschland haben</li>
          <li>Eine gültige E-Mail-Adresse angeben</li>
          <li>Alle erforderlichen Registrierungsinformationen wahrheitsgemäß ausfüllen</li>
        </ul>

        <h3>3. PRÄMIENPROGRAMM</h3>
        <p>
          Unser Prämienprogramm ermöglicht es Ihnen, durch das Abschließen von gesponserten 
          Angeboten Belohnungen zu verdienen. Die Anzahl der erforderlichen Angebote und der 
          Wert der Belohnung variieren je nach Programm.
        </p>
        <ul>
          <li>Sie müssen die erforderliche Anzahl von gesponserten Angeboten abschließen</li>
          <li>Angebote müssen innerhalb des angegebenen Zeitrahmens abgeschlossen werden</li>
          <li>Die ID-Verifizierung ist erforderlich, um Belohnungen zu erhalten</li>
          <li>Die Bearbeitung von Belohnungen kann 5-7 Werktage dauern</li>
        </ul>

        <h3>4. HAFTUNGSAUSSCHLUSS</h3>
        <p>
          Die auf dieser Website genannten Marken und Handelsnamen sind Eigentum ihrer 
          jeweiligen Inhaber und nicht mit dieser Promotion verbunden. Wir sind nicht 
          verantwortlich für Produkte oder Dienstleistungen Dritter.
        </p>

        <h3>5. ÄNDERUNGEN DER BEDINGUNGEN</h3>
        <p>
          Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Änderungen 
          werden auf dieser Seite veröffentlicht und treten sofort nach der Veröffentlichung 
          in Kraft.
        </p>

        <h3>6. GEISTIGES EIGENTUM</h3>
        <p>
          Alle Inhalte auf dieser Website, einschließlich Text, Grafiken, Logos und Software, 
          sind Eigentum von Rewards & Samples, LLC oder seinen Lizenzgebern und durch 
          Urheberrechtsgesetze geschützt.
        </p>

        <h3>7. HAFTUNGSBESCHRÄNKUNG</h3>
        <p>
          Wir haften nicht für direkte, indirekte, zufällige, besondere oder Folgeschäden, 
          die aus der Nutzung oder Unfähigkeit zur Nutzung dieser Website entstehen.
        </p>

        <h3>8. ANWENDBARES RECHT</h3>
        <p>
          Diese Bedingungen unterliegen den Gesetzen Deutschlands und werden nach diesen 
          ausgelegt. Alle Streitigkeiten werden vor deutschen Gerichten beigelegt.
        </p>

        <h3>9. KONTAKT</h3>
        <p>
          Wenn Sie Fragen zu diesen Bedingungen haben, kontaktieren Sie uns bitte.
        </p>

        <div className="last-updated">
          Zuletzt aktualisiert: Januar 2026
        </div>
      </div>
    </div>
  );
};

export default TermsDE;
